import axios from "axios";
import { baseURL, secretKey } from "../../../util/config";
import { GET_AFFILIATE, BLOCK_UNBLOCK_AFFILIATE, DELETE_AFFILIATE, GET_SINGLE_AFFILIATE } from "./affiliate.type";

// Get all affiliates
export const getAffiliate = (page, size, search, status) => (dispatch) => {
  let url = `${baseURL}affiliate/getAffiliates?page=${page}&size=${size}`;

  if (search) url += `&search=${search}`;
  if (status && status !== "all") url += `&status=${status}`;

  axios
    .get(url, { headers: { key: secretKey } })
    .then((res) => {
      console.log("Affiliates API response:", res.data);
      dispatch({
        type: GET_AFFILIATE,
        payload: {
          data: res.data.affiliates || [],
          total: res.data.totalAffiliates || 0
        },
      });
    })
    .catch((error) => {
      console.error("Error fetching affiliates:", error.response || error);
    });
};

// Block/Unblock affiliate
export const blockUnblockAffiliate = (affiliateId) => (dispatch) => {
  axios
    .patch(`${baseURL}affiliate/blockUnblock?affiliateId=${affiliateId}`, {}, { headers: { key: secretKey } })
    .then((res) => {
      console.log("Block/Unblock response:", res.data);
      if (res.data.status === true && res.data.affiliate) {
        dispatch({
          type: BLOCK_UNBLOCK_AFFILIATE,
          payload: res.data.affiliate,
        });
      }
    })
    .catch((error) => {
      console.log("Error blocking/unblocking affiliate:", error);
    });
};

// Delete affiliate
export const deleteAffiliate = (affiliateId) => (dispatch) => {
  axios
    .delete(`${baseURL}affiliate/delete?affiliateId=${affiliateId}`, { headers: { key: secretKey } })
    .then((res) => {
      console.log("Delete response:", res.data);
      if (res.data.status === true) {
        dispatch({
          type: DELETE_AFFILIATE,
          payload: affiliateId,
        });
      }
    })
    .catch((error) => {
      console.log("Error deleting affiliate:", error);
    });
};

// Get single affiliate profile
export const getSingleAffiliate = (affiliateId) => (dispatch) => {
  axios
    .get(`${baseURL}affiliate/profileByAdmin?affiliateId=${affiliateId}`, { headers: { key: secretKey } })
    .then((res) => {
      if (res.data.status === true && res.data.affiliate) {
        dispatch({
          type: GET_SINGLE_AFFILIATE,
          payload: res.data.affiliate,
        });
      }
    })
    .catch((error) => {
      console.log("Error fetching affiliate profile:", error);
    });
};